import { TitanBitmapTextField } from "@lib/titan2/dist/game/control/TitanBitmapTextField";
import { TitanText } from "@lib/titan2/dist/game/control/TitanText";
export class TitanCurrencyTextSelector {
    constructor() { }
    /**
    * Determines if the wrapper is using a supported currency code:
    * - supported currency code ->  returns bitmap text
    * - otherwise -> returns titan text
    */
    static createField(factory, parent, landscapeProperties, portraitProperties) {
        //We must get the currency code, in	 order to determine if its a supported currency , in which case use bit map text. 
        //Otherwise, use standard text.
        const currencyCode = factory.getWrapperConfig().getLogin().getCurrency();
        if (TitanCurrencyTextSelector.SUPPORTED_CURRENCY.includes(currencyCode)) {
            return TitanBitmapTextField.createField(parent, landscapeProperties.bitmapField, portraitProperties?.bitmapField);
        }
        return TitanText.createField(parent, landscapeProperties.textField, portraitProperties?.textField);
    }
}
TitanCurrencyTextSelector.SUPPORTED_CURRENCY = ["GBP", "USD", "EUR", "NONE"];
//# sourceMappingURL=TitanCurrencyTextSelector.js.map